module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/1-057cfad98cb27c9d9c8baf80953ef3e0.png";